import { useMemo } from 'react';

import { USER_STATUSES } from '@jebel/constants';

import { ChooseStatusChip, ChooseStatusChipOption } from 'shared/components/ui';

interface Props {
  status: string;
  options?: ChooseStatusChipOption[];
}

const USER_STATUS_COLORS = {
  [USER_STATUSES.active]: '#01B9A1',
  [USER_STATUSES.pending]: '#EF5C5C',
  [USER_STATUSES.inactive]: '#616DEE',
  [USER_STATUSES.rejected]: '#162D46',
  [USER_STATUSES.invitationSent]: '#FF782A',
};

const USER_STATUS_LABEL = {
  [USER_STATUSES.active]: 'Active',
  [USER_STATUSES.pending]: 'Pending Approval',
  [USER_STATUSES.inactive]: 'Inactive',
  [USER_STATUSES.rejected]: 'Rejected',
  [USER_STATUSES.invitationSent]: 'Invitation Sent',
};

export function ChooseUserStatusChip(props: Props) {
  const color = useMemo(() => {
    return USER_STATUS_COLORS[props.status];
  }, [props.status]);

  const label = useMemo(() => {
    return USER_STATUS_LABEL[props.status];
  }, [props.status]);

  return <ChooseStatusChip label={label} color={color} options={props.options} />;
}
